<pp-side-panel-menu-button
  [ppText]="'fleet_management' | ppTranslate"
  [ppDataTarget]="'Fleet Management icon'"
  [ppDataTest]="'fleetManagementMenuItem'"
  [ppIconSrc]="EIconPath.ICON_LEFT_MENU_BOAT_24"
  [ppActive]="ppRouterPath.includes('/fleet-management')"
  [ppDisabled]="ppDisabled"
  (ppAction)="goToFleetManagement()"
></pp-side-panel-menu-button>
